import { atom } from 'recoil'

export interface IAuthState {
  accessToken: string
  accessExpires: number
  refreshToken: string
  refreshExpires: number
}

const authAtom = atom<IAuthState>({
  default: { accessExpires: 0, accessToken: '', refreshExpires: 0, refreshToken: '' },
  key: 'auth',
})
export default authAtom
